export default "__VITE_ASSET__DAZrW6tL__"